import styled, { css } from 'styled-components'

export const WorkflowLogicContainer = styled.div`
  width: 100%;
  height: 100%;
  min-height: 500px;
  position: relative;
  ${(props) => props.theme.container};
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .react-flow {
    width: 100%;
    height: 100%;
    flex: 1;
  }

  .react-flow__background {
    background: ${(props) => props.theme.appBackground};
  }

  .react-flow__attribution {
    display: none;
  }

  .react-flow__edge-path {
    stroke: #ff9900;
    stroke-width: 2;
  }

  .react-flow__edge.selected .react-flow__edge-path {
    stroke: #d97f00;
    stroke-width: 3;
  }

  .react-flow__handle {
    width: 10px;
    height: 10px;
    background: #ff9900;
    border: 2px solid ${(props) => props.theme.appBackground};
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .react-flow__handle-left {
    left: 0;
  }

  .react-flow__handle-right {
    left: auto;
    right: 0;
    transform: translate(50%, -50%);
  }

  .react-flow__controls {
    box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    overflow: hidden;
  }

  .react-flow__controls-button {
    background: ${(props) => props.theme.appBackground};
    border-bottom: 1px solid ${(props) => props.theme.thinSeparator};

    svg {
      fill: ${(props) => props.theme.textColor};
    }
  }

  .react-flow__controls-button:hover {
    background: ${(props) => props.theme.glassHover};
  }
`

export const WorkflowLogicToolbar = styled.div`
  position: absolute;
  top: 1rem;
  z-index: 5;
  display: flex;
  align-items: center;
  padding: 0.5rem;
  gap: 1rem;
  border-radius: 10px;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.12);
`

export const WorkflowDropEmptyHint = styled.div<{ visible: boolean }>`
  position: absolute;
  inset: 0;
  display: ${(props) => (props.visible ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  pointer-events: none;
  color: ${(props) => props.theme.textColor};
  opacity: 0.55;
  font-size: 0.875rem;
  z-index: 1;
`

export const EdgeDeleteButton = styled.button<{ show?: boolean }>`
  position: absolute;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: ${(props) => props.theme.appBackground};
  color: ${(props) => props.theme.textColor};
  border: 1.5px solid #ff9900;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: all;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  opacity: ${(props) => (props.show ? 1 : 0)};
  transition: opacity 0.15s ease, background 0.15s ease, color 0.15s ease;

  &:hover {
    background: #ff9900;
    color: #fff;
  }
`

export const TaskNodeContainer = styled.div<{ root?: boolean; selected?: boolean }>`
  width: 180px;
  min-height: 70px;
  padding: 0.75rem 1rem;
  background: ${(props) => props.theme.appBackground};
  border-radius: 12px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border: 1px solid ${(props) => props.theme.thinSeparator};
  color: ${(props) => props.theme.textColor};
  transition: box-shadow 0.15s ease, border-color 0.15s ease, transform 0.15s ease;

  ${(props) =>
    props.root &&
    css`
      border-color: #ff9900;
    `}

  ${(props) =>
    props.selected &&
    css`
      box-shadow: 0px 6px 24px rgba(255, 153, 0, 0.35);
      border-color: #ff9900;
    `}

  &:hover {
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.18);
  }
`

export const TaskNodeTitle = styled.div`
  text-align: center;
  font-size: 0.8rem;
  font-weight: 500;
  word-break: break-word;
  pointer-events: none;
`

export const TaskNodeDelete = styled.button`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.15s ease, background 0.15s ease;

  svg {
    width: 12px;
    height: 12px;
  }

  ${TaskNodeContainer}:hover & {
    opacity: 1;
  }

  &:hover {
    background: rgba(255, 0, 0, 0.1);
  }
`
